export enum AuthenticationType {
    NONE = 'NONE',
    BASIC = 'BASIC',
    BEARER = 'BEARER',
    API_KEY = 'API_KEY',
    OAUTH2 = 'OAUTH2',
    CLIENT_CREDENTIALS = 'CLIENT_CREDENTIALS',
    JWT = 'JWT',
}

export enum WhatToDoWithTheResponse {
    USE_TO_ANSWER_CLIENT = 'USE_TO_ANSWER_CLIENT',
    SAVE_IN_CHAT = 'SAVE_IN_CHAT',
    CALL_EXTERNAL_API = 'CALL_EXTERNAL_API',
}

export interface Integration {
    id: number
    name: string
    description?: string
    context: string
    externalUrl?: string
    properties?: any
    headers?: any
    params?: any
    authenticationType: AuthenticationType
    authenticationData?: any
    whatToDoWithResponse: WhatToDoWithTheResponse
    createdAt: string
    updatedAt: string
    deleted: boolean
    companyId: number
}

export interface CreateIntegrationDto {
    name: string
    description?: string
    context: string
    externalUrl?: string
    properties?: any
    headers?: any
    params?: any
    authenticationType?: AuthenticationType
    authenticationData?: any
    whatToDoWithResponse?: WhatToDoWithTheResponse
    companyId: number
}

export interface UpdateIntegrationDto extends Partial<CreateIntegrationDto> {}
